import {APIRequest} from "../modules/APIRequest.js";

(async ()=>{
	var pending_login = false;
	$("#forgot-pw-form").submit(async function(e){
		if(pending_login) return;
		pending_login = true;
		e.preventDefault();
		const email = $("#forgot-pw-email-input").val().trim();
		
		$("#forgot-pw-btn").html(`<i class="fas fa-sync fa-spin"></i> Please wait...`).prop('disabled', true);
		
		var request = new APIRequest();
		request.set('forgotPw', 'email', email);
		
		var result = (await request.send()).forgotPw;
		if(result.errors.length){
			$("#forgot-pw-error").html('<i class="fas fa-skull-crossbones"></i> '+result.errors.join(" "));
			$("#forgot-pw-error").show();
			pending_login = false;
			$("#forgot-pw-btn").html(`<i class="fas fa-check-square"></i> Submit`).prop('disabled', false);
		}else{
			alert("Check your email for a password reset link.");
			location.href = "./dashboard.php";
		}
			
	});
})();

